import React, { useEffect } from "react";
import { RouteComponentProps } from "react-router";
import queryString from "query-string";
import { fetchRedirectToken } from "../../store/RedirectSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/rootReducer";
import { PageState } from "../../api/Types";
import { Loader } from "swyft-react-core";
import { Box, Typography } from "@material-ui/core";

type Props = RouteComponentProps;

export const RedirectPage: React.FC<Props> = (route: Props) => {
  const dispatch = useDispatch();

  const params = queryString.parse(route.location.search);

  const token = params["token"] as string;

  const { redirectToken, pageState, error } = useSelector((state: RootState) => state.redirect);

  useEffect(() => {
    dispatch(fetchRedirectToken(token));
  }, [dispatch, token]);

  if (!redirectToken || pageState === PageState.Loading) {
    return <Loader />;
  }

  if (pageState === PageState.Error || error) {
    return <div>Error</div>;
  }

  if (redirectToken.expiry < new Date().getTime()) {
    return (
      <Box>
        <Typography variant="h1">Link Expired</Typography>
      </Box>
    );
  }

  return (
    <div>
      <Box display="flex" justifyContent="center" alignItems="center" p={4}>
        <Typography variant="h1">Redirecting...</Typography>
      </Box>
      <Loader />
    </div>
  );
};
